import styled from 'styled-components';
import { colors } from '../../Shared/colors';

export const MainContainer = styled.div`
  height: 100%; 
  overflow-y: auto; 
  scrollbar-width: none;
  -ms-overflow-style: none;
  padding: 0.5rem 0;

  &::-webkit-scrollbar {
    display: none;
  }
  
  @media (max-width: 1024px) {
    padding: 0.3rem 0;
  }
  
  @media (max-width: 768px) {
    padding: 0.2rem 0;
  }
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 1.5rem;
  
  p {
    color: ${colors.textLight};
    font-size: clamp(0.8rem, 1.2vw, 1rem);
    margin: 0 0 1rem 0;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    padding: 0.5rem 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  }
  
  div {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    
    a {
      display: flex;
      align-items: center;
      text-decoration: none;
      color: ${colors.textMed};
      width: 100%;
      padding: 0.75rem 1rem;
      font-size: clamp(0.85rem, 1.1vw, 1rem);
      border-radius: 8px;
      transition: all 0.3s ease-out;
      position: relative;
      background: transparent;
      border: 1px solid transparent;
      
      &::before {
        content: '';
        position: absolute;
        left: -1rem;
        width: 4px;
        height: 100%;
        background: linear-gradient(135deg, ${colors.brown} 0%, #1a6b6b 100%);
        border-radius: 0 4px 4px 0;
        display: none;
        transition: all 0.3s ease-out;
      }
      
      &:hover {
        background: linear-gradient(135deg, ${colors.inputWhite} 0%, rgba(36, 147, 147, 0.05) 100%);
        color: ${colors.brown};
        border-color: rgba(36, 147, 147, 0.1);
        transform: translateX(4px);
        
        &::before {
          display: block;
        }
      }
      
      span {
        margin-left: 0.75rem;
        font-weight: 500;
        flex: 1;
      }
      
      svg {
        font-size: 1.2rem;
        transition: all 0.3s ease-out;
      }
      
      &:hover svg {
        transform: scale(1.1);
      }
    }
    
    .active {
      background: linear-gradient(135deg, ${colors.inputWhite} 0%, rgba(36, 147, 147, 0.08) 100%);
      color: ${colors.brown};
      border-color: rgba(36, 147, 147, 0.15);
      font-weight: 600;
      
      &::before {
        display: block;
      }
      
      svg {
        transform: scale(1.05);
      }
    }
  }
  
  @media (max-width: 1024px) {
    margin-bottom: 1rem;
    
    p {
      font-size: 0.8rem;
      margin-bottom: 0.75rem;
    }
    
    div {
      gap: 0.4rem;
      
      a {
        padding: 0.6rem 0.8rem;
        font-size: 0.85rem;
        
        span {
          margin-left: 0.6rem;
        }
        
        svg {
          font-size: 1.1rem;
        }
      }
    }
  }
  
  @media (max-width: 768px) {
    margin-bottom: 0.8rem;
    
    p {
      font-size: 0.75rem;
      margin-bottom: 0.6rem;
    }
    
    div {
      gap: 0.3rem;
      
      a {
        padding: 0.5rem 0.6rem;
        font-size: 0.8rem;
        
        span {
          margin-left: 0.5rem;
        }
        
        svg {
          font-size: 1rem;
        }
      }
    }
  }
`;
